import { useGenres } from "@/lib/api";
import theme from "@/styles/theme";
import { Autocomplete, Chip, TextField, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import InputLabel from "@mui/material/InputLabel";
import {useContext, useEffect, useState} from "react";
import AppContext from "@/context/AppContext";

const autocomplete = {
  "& .MuiFilledInput-root": {
    padding: ".1875rem 0 .1875rem 1rem",
    minHeight: "42px",
    "& ::placeholder": {
      color: "#1a1a1a",
      opacity: "1!important",
      textTransform: "uppercase",
      fontSize: "1rem",
    },

    "& input": {
      padding: "unset !important",
    },

    "& .MuiChip-root": {
      height: "1.75rem",
      borderRadius: ".25rem",
      color: theme.palette.common.white,
      margin: ".1875rem .5rem .1875rem 0",
      backgroundColor: theme.palette.primary.main,
    },
  },

  "& label": {
    display: "none",
  },
};

const chip = {
};

export const GenreSelectorMultiple = ({
  name = "genres",
  defaultValue,
  label,
  hint,
  onChange,
  variant,
  placeholder,
  required = false,
  helperText,
    maxCount = 3
}) => {
  const {setSnackbar} = useContext(AppContext);
  const {genres} = useGenres();
  const [selectedValues, setSelectedValues] = useState([]);
  const [isValid, setIsValid] = useState(defaultValue ?? !required);
  const [helper, setHelper] = useState('Bitte auswählen');

  useEffect(() => {
    if (selectedValues.length > maxCount) {
      setSnackbar({ type: 'warning', content: `Du kannst nur maximal ${maxCount} Genres wählen, alle weiteren werden nicht gespeichert`});
    }
    if (selectedValues.length === maxCount) {
      setHelper(`Du kannst maximal ${maxCount} Genres wählen`)
    } else {
      setHelper('Bitte auswählen');
    }
  }, [selectedValues]);


  const handleSelected = (event, values) => {
    if (required) {
      if (values == null || values.length === 0) {
        setIsValid(false);
      } else {
        setIsValid(true);
      }
    } else {
      setIsValid(true);
    }

    if (values.length > 1) { // Avoid duplicate Genres
      const lastAdded = values[values.length - 1];
      if (values.slice(0, (values.length - 1)).findIndex(v => lastAdded.id === v.id) > -1) {
        values.pop();
      }
    }

    setSelectedValues(values);

    if (onChange) {
      event.target.name = name;
      event.target.value = values.slice(0, maxCount);
      onChange(event, values.slice(0, maxCount));
    }
  };

  return (
    <>
      <InputLabel
        sx={{
          color: isValid
            ? theme.palette.common.black
            : theme.palette.error.main,
        }}
      >
        {label}{required && '*'}{" "}
        {hint && (
          <Typography
            variant="caption"
            component="span"
            sx={{
              "&.MuiTypography-root": {
                color: isValid ? grey[600] : theme.palette.error.main,
              },
            }}
          >
            ({hint})
          </Typography>
        )}
      </InputLabel>
      <Autocomplete
        multiple
        sx={autocomplete}
        name={name}
        options={genres}
        defaultValue={defaultValue}
        getOptionLabel={(option) => option.title}
        onChange={(event, newValues) => {
          if (newValues.length > maxCount) {
            newValues.pop();
          }
          handleSelected(event, newValues);
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              sx={chip}
              label={`${option.title}`}
              key={index}
              {...getTagProps({index})}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="filled"
            placeholder={helper}
            sx={{
              "& .MuiFilledInput-root": {
                "&::before": {
                  borderColor: isValid ? "transparent" : "#c33132 !important",
                },
              },
            }}
          />
        )}
      />
      {helperText &&
          <Typography variant="helperText" component="p">
            {helperText}
          </Typography>
      }
    </>
  );
};
